import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17e7d904"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper-table-graph"
};
const _hoisted_2 = {
  class: "header-section"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0,
  class: "graph-title"
};
const _hoisted_6 = {
  class: "body-section"
};
const _hoisted_7 = {
  class: "table-with-footer-section"
};
const _hoisted_8 = {
  class: "table-grapher-wrapper"
};
const _hoisted_9 = {
  class: "graph-footer"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ruler"
}, null, -1));
const _hoisted_12 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_item = _resolveComponent("skeleton-item");
  const _component_table_skeleton = _resolveComponent("table-skeleton");
  const _component_empty_space = _resolveComponent("empty-space");
  const _component_center_wrapper = _resolveComponent("center-wrapper");
  const _component_table_grapher = _resolveComponent("table-grapher");
  const _component_total_grapher = _resolveComponent("total-grapher");
  const _component_pager_item = _resolveComponent("pager-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.tableLoading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_skeleton_item, {
    color: "#CCC",
    customStyle: {
      width: '50%',
      marginBottom: '0.5rem'
    }
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [$options.dataPresent ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.graphTitle), 1)) : _createCommentVNode("", true)]))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [$props.tableLoading ? (_openBlock(), _createBlock(_component_table_skeleton, {
    key: 0,
    headers: $props.graphHeaders,
    length: 10
  }, null, 8, ["headers"])) : !$props.tableLoading && $props.positions.length === 0 ? (_openBlock(), _createBlock(_component_center_wrapper, {
    key: 1
  }, {
    default: _withCtx(() => [_createVNode(_component_empty_space, {
      message: `No data available for ${$props.graphTitle}`
    }, null, 8, ["message"])]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_table_grapher, {
    key: 2,
    onSortTable: _cache[0] || (_cache[0] = data => _ctx.$emit('sortTable', data)),
    graphId: $props.graphId,
    graphData: this.positions,
    graphMinMax: this.minMax,
    graphHeaders: $props.graphHeaders,
    fetchingData: $data.fetchingData,
    graphHeaderDescriptions: $props.description,
    noProductImage: $props.noProductImage,
    productFullText: $props.productFullText,
    setStriped: $props.setStriped,
    breakProductName: $props.breakProductName,
    truncateProductName: $props.truncateProductName,
    currentViewPeriodOptions: $props.currentViewPeriodOptions,
    pageRenderedLoading: $props.pageRenderedLoading,
    sortBy: $props.sortBy,
    sortDirection: $props.sortDirection
  }, null, 8, ["graphId", "graphData", "graphMinMax", "graphHeaders", "fetchingData", "graphHeaderDescriptions", "noProductImage", "productFullText", "setStriped", "breakProductName", "truncateProductName", "currentViewPeriodOptions", "pageRenderedLoading", "sortBy", "sortDirection"]))]), _createElementVNode("div", _hoisted_9, [$props.tableLoading ? (_openBlock(), _createBlock(_component_table_skeleton, {
    key: 0,
    noHeader: true,
    length: 1,
    headers: $props.graphHeaders
  }, null, 8, ["headers"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$options.showTotal && $options.dataPresent ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createVNode(_component_total_grapher, {
    graphHeaders: $props.graphHeaders,
    graphData: $options.positionsTotal,
    totalLoading: $props.totalLoading,
    showTotalItem: $options.showTotalItem,
    dataWidths: $props.dataWidths,
    notAllowed: ['keyword_bid']
  }, null, 8, ["graphHeaders", "graphData", "totalLoading", "showTotalItem", "dataWidths"])])) : _createCommentVNode("", true), $props.totalCount > $props.pageSize ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_pager_item, {
    currentPage: $props.currentPage,
    pageSize: $props.pageSize,
    totalCount: $props.totalCount,
    onPage: _cache[1] || (_cache[1] = data => _ctx.$emit('page', data))
  }, null, 8, ["currentPage", "pageSize", "totalCount"])])) : _createCommentVNode("", true)], 64))])])])]);
}